export default __webpack_public_path__ + "static/media/bulgo-screenshot-04.35a40dc6.png";